// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import './AiUseCases.scss'

interface AIUseCaseItemProps {
  imageSrc: string
  title: string
}

const AIUseCaseItem: React.FC<AIUseCaseItemProps> = ({ imageSrc, title }): JSX.Element => {
  return (
    <div className="aiusecases-icons-item gap-s4 mx-auto mx-md-0">
      <img src={imageSrc} alt={`${title} icon`} loading="lazy" />
      <h3 className="h3">{title}</h3>
    </div>
  )
}

const AiUseCases: React.FC = (): JSX.Element => {
  return (
    <div className="aiusecases-container px-s10 py-s11 d-none d-sm-flex">
      <div className="internal-container gap-s9">
        <div className="aiusecases-title-container gap-s4">
          <h2>
            <span className="display-4">Serving a Wide Range of AI Use Cases</span>
          </h2>
          <span className="lead">Our cloud platform supports AI use cases, including:</span>
        </div>
        <div className="aiusecases-icons-container py-s4 row-gap-s9">
          <AIUseCaseItem title="Bots" imageSrc="/images/bots-icon.png" />
          <AIUseCaseItem title="Model training" imageSrc="/images/modelTraining-icon.png" />
          <AIUseCaseItem title="Model fine-tuning" imageSrc="/images/modelFineTuning-icon.png" />
          <AIUseCaseItem title="AI inference" imageSrc="/images/AIInference-icon.png" />
          <AIUseCaseItem title="AI app deployments" imageSrc="/images/AiAppDeploy-icon.png" />
          <AIUseCaseItem title="Performance benchmarking" imageSrc="/images/Benchmark-icon.png" />
        </div>
      </div>
    </div>
  )
}

export default AiUseCases
